import { PropsWithChildren } from "react";
import { Provider } from "react-redux";
import { store } from "store";

/**
 * Form wrapped in Provider,
 * used in Modal components that don't have access to the store
 */
export const StoreProviderForm = ({ children }: PropsWithChildren<any>) => {
    return <Provider store={store}>{children}</Provider>;
};
